import { render, staticRenderFns } from "./ComponentGroup.vue?vue&type=template&id=43a11b34&"
import script from "./ComponentGroup.vue?vue&type=script&lang=js&"
export * from "./ComponentGroup.vue?vue&type=script&lang=js&"
import style0 from "./ComponentGroup.vue?vue&type=style&index=0&id=43a11b34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports